"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getProfileTierLabelI18nKey = exports.getRoleI18nKey = exports.getScopeGroupI18nKey = exports.getDataSyncsSyncI18nKey = exports.getDataSyncsDataI18nKey = exports.getHubSpotFeatureI18nKey = exports.getTierI18nKey = exports.getCategoryFeatureI18nKey = exports.getCategoryI18nKey = exports.getSuperCategoryI18nKey = void 0;

var _memoize = _interopRequireDefault(require("hs-lodash/memoize"));

var PartnerTypes = _interopRequireWildcard(require("../constants/solutions/PartnerType"));

var getSuperCategoryI18nKey = function getSuperCategoryI18nKey(superCategory) {
  return "ecosystemMarketplaceCore.groupTags.superCategory." + superCategory;
};

exports.getSuperCategoryI18nKey = getSuperCategoryI18nKey;

var getCategoryI18nKey = function getCategoryI18nKey(category) {
  return "ecosystemMarketplaceCore.groupTags.category." + category;
};

exports.getCategoryI18nKey = getCategoryI18nKey;

var getCategoryFeatureI18nKey = function getCategoryFeatureI18nKey(category, feature) {
  return "ecosystemMarketplaceCore.groupTags.categoryFeature." + category + "." + feature;
};

exports.getCategoryFeatureI18nKey = getCategoryFeatureI18nKey;

var getTierI18nKey = function getTierI18nKey(tier) {
  return "ecosystemMarketplaceCore.groupTags.tier." + tier;
};

exports.getTierI18nKey = getTierI18nKey;

var getHubSpotFeatureI18nKey = function getHubSpotFeatureI18nKey(key) {
  return "ecosystemMarketplaceCore.groupTags.hubspotFeature." + key;
};

exports.getHubSpotFeatureI18nKey = getHubSpotFeatureI18nKey;

var getDataSyncsDataI18nKey = function getDataSyncsDataI18nKey(data) {
  return "ecosystemMarketplaceCore.dataSyncs.data." + data;
};

exports.getDataSyncsDataI18nKey = getDataSyncsDataI18nKey;

var getDataSyncsSyncI18nKey = function getDataSyncsSyncI18nKey(sync) {
  return "ecosystemMarketplaceCore.dataSyncs.sync." + sync;
};

exports.getDataSyncsSyncI18nKey = getDataSyncsSyncI18nKey;

var getScopeGroupI18nKey = function getScopeGroupI18nKey(scopeGroup) {
  var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'label';
  return "ecosystemMarketplaceCore.scopes.scopeGroups." + scopeGroup + "." + key;
};

exports.getScopeGroupI18nKey = getScopeGroupI18nKey;
var getRoleI18nKey = (0, _memoize.default)(function (role, portalScopes) {
  var key = role.toLowerCase().replace(/ /g, '-');

  if (portalScopes) {
    if (portalScopes.includes('sales-nav-access')) {
      key += '-sales';
    } else if (portalScopes.includes('service-access')) {
      key += '-service';
    }
  }

  return "roles." + key;
});
exports.getRoleI18nKey = getRoleI18nKey;

var getProfileTierLabelI18nKey = function getProfileTierLabelI18nKey(tier, partnerType, labelKey) {
  var I18N_BASE = 'ecosystemMarketplaceCore.solutions.profileTier';

  switch (partnerType) {
    case PartnerTypes.PROVIDER:
      {
        return I18N_BASE + "." + PartnerTypes.PROVIDER + "." + labelKey;
      }

    case PartnerTypes.PARTNER:
    case PartnerTypes.RESELLER:
      {
        return I18N_BASE + "." + PartnerTypes.PARTNER + "." + tier + "." + labelKey;
      }

    case PartnerTypes.DIRECTORY_USER:
    default:
      {
        return null;
      }
  }
};

exports.getProfileTierLabelI18nKey = getProfileTierLabelI18nKey;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ecosystem-marketplace-core/static-1.1225/js/utils/i18n.js
// module id = 48
// module chunks = 209 210 211 212